import { Controller } from "@hotwired/stimulus"
import moment from 'moment'

export default class extends Controller {
  static targets = ["eventForm"]

  connect() {
    this.setInitialTimeVisibility();
    document.querySelector('.event_all_day').addEventListener('change', this.setTimeVisibility.bind(this));
    const resetImage = document.querySelector('.change-event-image-file');
    if (resetImage) {
      resetImage.addEventListener('click', this.resetImageField.bind(this));
    }
  }

  setInitialTimeVisibility() {
    if (document.querySelector('#event_all_day:checked')) {
      this.hideTimeFields();
    } else {
      this.showTimeFields();
    }
  }
  setTimeVisibility() {
    if (document.querySelector('#event_all_day:checked')) {
      this.hideTimeFields();
    } else {
      this.showTimeFields();
    }
  }
  hideTimeFields() {
    document.querySelectorAll('.time').forEach((timeField) => {
      timeField.parentElement.style.display = 'none'
    })
  }
  showTimeFields() {
    document.querySelectorAll('.time').forEach((timeField) => {
      timeField.parentElement.style.display = 'block'
    })
  }
  resetImageField(event) {
    event.preventDefault();
    const fileInput = `
      <div class="form-group file optional event_image">
        <label class="control-label file optional" for="event_image">Image</label>
        <input class="form-control-file file optional" accept="image/x-png,image/gif,image/jpeg" type="file" name="event[image]" id="event_image">
      </div>
    `
    document.querySelector('.image.upload').innerHTML = fileInput
  }
  validateForm(event) {
    const imageInput = document.querySelector('#event_image');
    const errors = [];
    const image = imageInput?.files[0];
    if (!image) {
      return;
    }
    if (image.size > 5028640) {
      errors.push('Image size must be less than 5 megabytes');
    }
    if (!this.isValidImageType(image.type)) {
      errors.push(`Image type ${image.type} is not allowed`);
    }
    if (errors.length > 0) {
      event.preventDefault();
      alert(errors.join("\n"));
    }
  }
  isValidImageType(fileType) {
    const allowedTypes = [
      "image/x-png",
      "image/png",
      "image/gif",
      "image/jpeg",
      "image/jpg",
    ]
    return allowedTypes.includes(fileType);
  }

}